import { OrganizationService } from '../types';
import { OrgMember, OrgInstance } from '@/types/orgTypes';
import { patchMemberPreferences } from '@/infrastructure/adapters/memberPreferencesCache';

export class OrganizationServiceImpl {
  constructor(private readonly organizationService: OrganizationService) {}

  // Delegate interface methods to adapter
  async fetchOrgMember(userId: string): Promise<OrgMember | null> {
    return this.organizationService.fetchOrgMember(userId);
  }

  async updateOrgMember(userId: string, updateData: any): Promise<void> {
    return this.organizationService.updateOrgMember(userId, updateData);
  }

  async fetchMemberPreferences(userId: string): Promise<Record<string, any>> {
    return this.organizationService.fetchMemberPreferences(userId);
  }

  async updateMemberPreferences(userId: string, preferences: Record<string, any>): Promise<void> {
    return this.organizationService.updateMemberPreferences(userId, preferences);
  }

  async patchMemberPreferences(userId: string, patch: Record<string, any>): Promise<void> {
    return patchMemberPreferences(userId, patch);
  }

  async fetchOrgInstance(orgInstanceId: string): Promise<OrgInstance | null> {
    return this.organizationService.fetchOrgInstance(orgInstanceId);
  }

  async fetchMyOrgInstance(): Promise<OrgInstance | null> {
    return this.organizationService.fetchMyOrgInstance();
  }

  async fetchOrgInstanceByUserId(userId: string): Promise<OrgInstance | null> {
    return this.organizationService.fetchOrgInstanceByUserId(userId);
  }

  async updateOrgInstanceDisplayName(userId: string, displayName: string): Promise<void> {
    return this.organizationService.updateOrgInstanceDisplayName(userId, displayName);
  }

  async updateOrgInstanceImmersalToken(userId: string, token: string): Promise<void> {
    return this.organizationService.updateOrgInstanceImmersalToken(userId, token);
  }

  // Business logic methods (not in interface)
  async updateOrgMemberFullName(userId: string, fullName: string): Promise<void> {
    return this.updateOrgMember(userId, { full_name: fullName });
  }

  async updateOrgMemberAvatar(userId: string, avatarUrl: string): Promise<void> {
    return this.updateOrgMember(userId, { avatar_url: avatarUrl });
  }

  async updateOrgMemberImmersalWatermark(userId: string, enabled: boolean): Promise<void> {
    return this.updateOrgMember(userId, { display_immersal_watermark: enabled });
  }
}

